import React from "react";
import { GOLD } from "../constants/theme";

/**
 * The New shelf: what landed in the last few days, above everything else.
 *
 * It has to read as a different KIND of thing from the category shelves, or
 * it is just a fourth category called New. The shelves below are a Bebas
 * label and a hairline rule, deliberately quiet, because they are furniture
 * a coach scans past. So this one is the opposite: an enclosed panel with a
 * gold edge and a warm wash, the only boxed row on the page.
 *
 * It sizes to its contents rather than spanning the page. That is the whole
 * reason it lays the cards out itself instead of reusing the shared grid:
 * an auto-fill grid stretched to full width puts one new masterclass in a
 * wide box of empty space, which reads as something failed to load. Hugging
 * makes one new thing look like a deliberate highlight and still fills the
 * row when three land at once.
 *
 * The date range is said out loud rather than implied. "New" with no window
 * is a label a coach stops trusting the moment they recognise something that
 * has been sitting there a month.
 */
export function NewShelf({ items, C, dark, days, renderCard }) {
  if (!items.length) return null;
  return (
    <div style={{
      width: "fit-content",
      maxWidth: "100%",
      border: `1px solid ${GOLD}${dark ? "3A" : "4D"}`,
      borderRadius: 18,
      background: dark
        ? `linear-gradient(180deg, ${GOLD}0F 0%, ${GOLD}05 42%, transparent 100%)`
        : `linear-gradient(180deg, ${GOLD}2E 0%, ${GOLD}12 42%, transparent 100%)`,
      padding: "18px 18px 20px",
      marginBottom: 34,
    }}>
      <div style={{display:"flex",alignItems:"center",gap:9,flexWrap:"wrap",margin:"0 0 16px"}}>
        <span aria-hidden="true" style={{
          width:7,height:7,borderRadius:"50%",background:GOLD,
          boxShadow:`0 0 10px ${GOLD}99`,flexShrink:0,
        }}/>
        <span style={{
          fontFamily:"'Bebas Neue', sans-serif",fontSize:22,letterSpacing:1.6,
          color:C.text,lineHeight:1,
        }}>Just added</span>
        <span aria-hidden="true" style={{color:C.textDim,fontSize:12}}>·</span>
        <span style={{fontSize:11.5,color:C.textDim}}>
          {items.length === 1 ? "In the last" : `${items.length} in the last`} {days} days
        </span>
      </div>
      <div style={{display:"flex",flexWrap:"wrap",gap:18}}>
        {items.map(item => (
          // A fixed-ish basis rather than 1fr: inside a hugging panel a
          // stretching card would blow its cover image up to the full page
          // width and push everything below the fold.
          <div key={item.id} style={{flex:"0 1 300px",minWidth:250,maxWidth:380}}>
            {renderCard(item)}
          </div>
        ))}
      </div>
    </div>
  );
}
